/**
 * Patch add confirmation + fly-to-cart.
 * Used on search, collections, and Buy patches — not the tote customizer.
 */
(function () {
  const FLY_MS = 1360;
  const ADDED_MS = 1400;

  function cartLink() {
    return document.querySelector('[data-cart-link]');
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function pulseCart() {
    const link = cartLink();
    if (!(link instanceof HTMLElement)) return;
    link.classList.remove('is-receiving');
    void link.offsetWidth;
    link.classList.add('is-receiving');
    window.setTimeout(() => link.classList.remove('is-receiving'), 520);
  }

  /**
   * @param {HTMLButtonElement} button
   * @param {{ addedLabel?: string; idleLabel?: string; restoreMs?: number; restoreMs?: number }} [opts]
   */
  function confirmButton(button, opts) {
    if (!(button instanceof HTMLButtonElement)) return;
    const addedLabel = (opts && opts.addedLabel) || 'Added';
    const idleLabel = (opts && opts.idleLabel) || 'Add';
    const restoreMs = (opts && (opts.restoreMs || opts.restoreMs)) || ADDED_MS;
    window.clearTimeout(button._tayAddedTimer);
    button.disabled = true;
    button.classList.add('is-added');
    button.textContent = addedLabel;
    button._tayAddedTimer = window.setTimeout(() => {
      button.classList.remove('is-added');
      if (button.isConnected && !button.hasAttribute('data-keep-added')) {
        button.textContent = idleLabel;
        button.disabled = false;
      }
    }, restoreMs);
  }

  /**
   * @param {{ imageUrl?: string; fromEl?: Element | null; fromRect?: DOMRect | null; fromRect?: DOMRect | null }} opts
   */
  function flyToCart(opts) {
    const imageUrl = opts && opts.imageUrl ? String(opts.imageUrl) : '';
    const start =
      (opts && (opts.fromRect || opts.fromRect)) ||
      (opts && opts.fromEl instanceof Element ? opts.fromEl.getBoundingClientRect() : null);
    const cart = cartLink();
    if (!start || !cart) {
      pulseCart();
      return;
    }
    if (reducedMotion() || !imageUrl) {
      pulseCart();
      return;
    }

    const dest = cart.getBoundingClientRect();
    const size = 52;
    const x0 = start.left + start.width / 2 - size / 2;
    const y0 = start.top + Math.min(start.height, 56) / 2 - size / 2;
    const x1 = dest.left + dest.width / 2 - size / 2;
    const y1 = dest.top + dest.height / 2 - size / 2;
    const midX = x0 + (x1 - x0) * 0.42;
    const midY = Math.min(y0, y1) - 72;

    const node = document.createElement('img');
    node.className = 'bbs-patch-fly';
    node.src = imageUrl;
    node.alt = '';
    node.width = size;
    node.height = size;
    node.style.transform = `translate(${x0}px, ${y0}px) scale(1)`;
    document.body.appendChild(node);

    const finish = () => {
      node.remove();
      pulseCart();
    };

    if (typeof node.animate !== 'function') {
      window.setTimeout(finish, 120);
      return;
    }

    const motion = node.animate(
      [
        { transform: `translate(${x0}px, ${y0}px) scale(1)`, opacity: 1, offset: 0 },
        { transform: `translate(${midX}px, ${midY}px) scale(0.92)`, opacity: 1, offset: 0.48 },
        { transform: `translate(${x1}px, ${y1}px) scale(0.22)`, opacity: 0.75, offset: 1 },
      ],
      {
        duration: FLY_MS,
        easing: 'cubic-bezier(.22,.7,.18,1)',
        fill: 'forwards',
      }
    );
    if (motion.finished) {
      motion.finished.then(finish).catch(finish);
    } else {
      window.setTimeout(finish, FLY_MS);
    }
  }

  /**
   * @param {Element} root
   * @returns {string}
   */
  function imageFrom(root) {
    if (!(root instanceof Element)) return '';
    const img = root.querySelector('img');
    if (img instanceof HTMLImageElement) return img.currentSrc || img.src || '';
    return root.getAttribute('data-image') || '';
  }

  const api = {
    flyToCart,
    confirmButton,
    pulseCart,
    imageFrom,
  };
  api.flyToCart = flyToCart;
  api.confirmButton = confirmButton;
  api.imageFrom = imageFrom;
  window.TAY_patchCartFx = api;
  window.TAY_patchCartFx = api;
})();
